import { CAMPAIGN_ENUM_TYPES } from '../../../shared/constants'

/**
 * Which city plans use the server-paginated pages.
 *
 * Letterbox plans are the ones that grow to thousands of missions; hand to
 * hand plans stay on the legacy pages for now. `?legacy=1` in the URL is a
 * one-release escape hatch back to the old page for a letterbox plan.
 *
 * @param {?{type: string}} campaign
 * @param {?{search: string}} [location]
 * @returns {boolean}
 */
export const isCityPlanV2 = (campaign, location) => {
  if (!campaign || campaign.type !== CAMPAIGN_ENUM_TYPES.LETTERBOX) return false
  const search = (location && location.search) || ''
  return !/[?&]legacy=1(&|$)/.test(search)
}
